import dynamic from "next/dynamic";

export const StatisticsHexagons = dynamic(() => import("./component"));
